import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Eye, FileText } from "lucide-react";
import { API_BASE } from "@/lib/api";
import { BrandLockup } from "@/components/Brand";
import { Skeleton } from "@/components/ui/skeleton";
import { AudioWrap, RecapCard, SampleBlock } from "@/components/WrapReport";

function Body({ d, notFound }) {
  if (notFound)
    return (
      <div data-testid="wrap-share-not-found" className="pb-card mt-10 flex flex-col items-center gap-3 p-16 text-center">
        <FileText className="h-10 w-10 text-neutral-300" />
        <p className="font-display text-xl font-bold">Report not found</p>
      </div>
    );
  if (!d) return <Skeleton className="h-64 rounded-2xl" />;
  if (d.kind === "recap") return <RecapCard recap={d.recap} source={d.source} note={d.not_combined_note} />;
  if (d.kind === "sample") return <SampleBlock sample={d.sample} />;
  return (
    <>
      <AudioWrap audio={d.audio} source={d.source} note={d.not_combined_note} />
      {d.sample && <div className="mt-8"><SampleBlock sample={d.sample} /></div>}
    </>
  );
}

export default function WrapShare() {
  const { slug } = useParams();
  const [d, setD] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    axios.get(`${API_BASE}/public/wrap/${slug}`).then((r) => setD(r.data)).catch(() => setNotFound(true));
  }, [slug]);
  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-40 border-b border-[#E7DFCC] bg-[#F7EFDD]/88 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3.5 sm:px-6 lg:px-8">
          <BrandLockup />
          <span data-testid="shared-badge" className="flex items-center gap-1.5 rounded-full border border-[#E7DFCC] bg-white px-3 py-1 text-xs font-medium text-[#6B7A80]">
            <Eye className="h-3.5 w-3.5" /> Read-only shared report
          </span>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <Body d={d} notFound={notFound} />
        <p className="mt-12 text-center text-xs text-[#9aa7ab]">Powered by Playbook Distro · Sound-performance analytics</p>
      </main>
    </div>
  );
}
